($ => {

    $('.Benefits-tabs li').click(function (ev) {
        let click = $(this)

        if( !click.hasClass('active')) {
            let wantedTab = click.data('tab')

            $('.Benefits-slide').slideUp()

            $(`.Benefits-slide${wantedTab}`).slideDown()

            $('.Benefits-tabs .active').removeClass('active')

            $(`.Benefits-tab${wantedTab}`).addClass('active')
        }

    })

})(jQuery)
